import React, { Component } from "react";
import Introduce from "./Introduce";
import Tutorial from "./Tutorial";

export default class Popup extends Component {
  render() {
    return (
      <div className="menu-popup">
        <div
          // className="general-default"
          style={{
            zIndex:12,
            // width:
            //   this.props.typeMenu === "default"
            //     ? `calc(100vw - 300px)`
            //     : `calc(100vw - 71px)`,
          }}
        >
          {this.props.type === "introduce" ? (
            <Introduce close = {this.props.close}></Introduce>
          ) : (
            <Tutorial close = {this.props.close}></Tutorial>
          )}
        </div>
      </div>
    );
  }
}
